import React from "react";
import ExtraBidHeader from "./headers/ExtraBidHeader";
import MaxBidHeader from "./headers/MaxBidHeader";
import MarketsBidHeader from "./headers/MarketsBidHeader";
import {MultiplierHeader} from "./headers/MultiplierHeader";
import {ExtraBidBody} from "./bodies/ExtraBidBody";
import {MaxBidBody} from "./bodies/MaxBidBody";
import {MarketBidBody} from "./bodies/MarketBidBody";
import {MultiplierBody} from "./bodies/MultiplierBody";

export const getHeaderComponent = (props) => {
    const {
        selectedTab,
        selectedType,
        allSelected,
        someSelected,
        handleSelectAll,
        sortConfig,
        handleSortChange,
        filters,
        handleFilterChange,
        baseData,
        filteredData
    } = props;

    const commonProps = {
        hotelOrGroupType: selectedType,
        allSelected,
        someSelected,
        onSelectAll: handleSelectAll,
        sortConfig,
        onSortChange: handleSortChange,
        filters,
        onFilterChange: handleFilterChange,
        data: baseData,
        hasDeletableRow: filteredData.some(row => row.can_delete),
    };

    switch (selectedTab) {
        case "extra_bid":
            return () => <ExtraBidHeader {...commonProps} />;
        case "max_bid":
            return () => <MaxBidHeader {...commonProps} />;
        case "market_bids":
            return () => <MarketsBidHeader {...commonProps} />;
        default:
            return () => <MultiplierHeader {...commonProps} />;
    }
};

export const getBodyComponent = (props) => {
    const {
        selectedTab,
        tableData,
        selectedRows,
        setSelectedRows,
        updateMultiplierRow,
        deleteSingleRow
    } = props;

    const commonProps = {
        rows: tableData,
        selectedRows,
        setSelectedRows,
        updateRow: updateMultiplierRow,
        onDeleteRow: deleteSingleRow,
    };

    switch (selectedTab) {
        case "extra_bid":
            return () => <ExtraBidBody {...commonProps} />;
        case "max_bid":
            return () => <MaxBidBody {...commonProps} />;
        case "market_bids":
            return () => <MarketBidBody {...commonProps} />;
        default:
            return () => <MultiplierBody {...commonProps} />;
    }
};